const countryList = {
    "success": 1,
    
    "data": [{
        "id": 38,
        "sortname": "CA",
        "name": "Canada",
        "phonecode": "+1"
    },
    {
        "id": 231,
        "sortname": "US",
        "name": "United States",
        "phonecode": "+1"
    }]
}
export default countryList;
